import { addDays, format } from 'date-fns';

export const TENANT_ID = {
  EDI: 'EDI',
  SHNG: 'SHNG',
  AVA: 'AVA',
  BAG: 'BAG',
  LVN: 'LVN',
  MTN: 'MTN',
};

export const TENANT_WITH_BIRTHDATE = [TENANT_ID.BAG, TENANT_ID.LVN];

/** Tenants where Fachinteressent (NEFI) login and registration are not permitted */
export const FACHINTERESSENT_BLOCKED_TENANTS = [TENANT_ID.EDI, TENANT_ID.AVA];

/** Whether a Fachinteressent from another BU may access this tenant's portal. */
export const FACHINTERESSENT_CROSS_BU_ALLOWED = {
  [TENANT_ID.BAG]: true,
  [TENANT_ID.MTN]: true,
  [TENANT_ID.LVN]: true,
  [TENANT_ID.SHNG]: true,
  [TENANT_ID.EDI]: false,
  [TENANT_ID.AVA]: false,
};

export const FACHINTERESSENT_ACCESS_DENIED_MESSAGE =
  'Ihr Konto ist nicht für den Zugriff auf e-fix in des ausgewählten Netzbetreibers berechtigt. Bitte melden Sie sich im Fachinteressenten-Bereich des Netzbetreibers an, über den Sie sich ursprünglich für e-fix registriert haben.';

export const PORTAL_SWITCH_TENANT_IDS = [
  TENANT_ID.EDI,
  TENANT_ID.SHNG,
  TENANT_ID.AVA,
  TENANT_ID.BAG,
  TENANT_ID.LVN,
  TENANT_ID.MTN,
];

export const FORM_CONSTANTS = {
  IMAGE_SIZE: 40,
  NE: 'NE',
  DEB: 'DEB',
  TAGS_EVENTS: {
    STROM: 'Strom',
    GAS: 'Gas',
    NEU: 'Neu',
    ONLINE: 'Online',
    KOSTENPFLICHTIG: 'Kostenpflichtig',
  },

  FREETEXT_INPUT: 500,
  ACCEPTED_FORM_INPUT_FILE_TYPES: [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/gif',
    'application/pdf',
  ],
  MAX_UPLOAD_FILE_COUNT: 10,
  MAX_UPLOAD_TOTAL_FILE_SIZE: 7000000,
};
export const STORAGE_KEY = {
  TENANT_ID: 'clientID',
  JWT: 'efix-token',
  FORM_DEBUG: 'form-debug',
  IAM: 'IAM',
  DEB_SELECTED_TEST_SUITE: 'deb-selected-test-suite',
  NE_SELECTED_TEST_SUITE: 'ne-selected-test-suite',
  NEFI_SELECTED_TEST_SUITE: 'nefi-selected-test-suite',
  FILL_NE_FORM: 'fill-ne-form',
  FILL_NEFI_FORM: 'fill-nefi-form',
  FILL_DEB_FORM: 'fill-deb-form',
  ENERGY_EXTENSION: 'energy-extension',
  GAS_EXTENSION: 'gas-extension',
  MOCK_FACHINTERESSENT: 'mock-fachinteressent',
};

export const TAGS_ARTICLES = {
  STROM: 'Strom',
  GAS: 'Gas',
  NEU: 'Neu',
};
export const OVERVIEW_LIST_TYPES = {
  event: 'event',
  article: 'article',
};
export const AEM_PAGE_TEMPLATE = {
  PUBLIC_PAGE: 'publicpage',
  CONTENT_PAGE: 'contentpage',
  PUBLIC_FOUNDATION_PAGE: 'publicfoundationngpage',
  HOMEPAGE: 'homepage',
  REACT_APP: 'react-app',
  ARTICLE: 'article',
  EVENT: 'event',
};
export const PUBLIC_AEM_PAGE_TEMPLATES = [
  AEM_PAGE_TEMPLATE.PUBLIC_PAGE,
  AEM_PAGE_TEMPLATE.PUBLIC_FOUNDATION_PAGE,
];
export const EIV_ENTRY_TYPE = {
  MAIN: 1,
  GUEST: 2,
  NULL: null,
};

export const EINTRAGUNG_ALS_ID = {
  INSTALLER: 1,
  FACHINTERESSENT: 4,
};

export const EIV_ENTRY_TYPE_TO_GERMAN = {
  [EIV_ENTRY_TYPE.MAIN]: 'Stammeintrag',
  [EIV_ENTRY_TYPE.GUEST]: 'Gasteintrag',
};

// Note: status 5 and 6 are FE specific, not coming from EIV
export const EIV_STATUS = {
  NOT_SET: null,
  ARCHIVED: 1,
  INACTIVE: 2,
  IN_PROGRESS: 3,
  ACTIVE: 4,
  NEW: 5,
  DELETED: 6,
};
export const EXPERT_STATUS_ACCOUNT_CREATION = {
  IN_PROGRESS: 'Bitte auf die Bearbeitung warten.',
  INACTIVE: 'Bitte die Eintragung über Kachel „Datenerfassungsblatt“ verlängern.',
};
export const EIV_STATUS_SALES_FORCE = {
  ACTIVE: 'Active',
  IN_PROGRESS: 'pending',
  NOT_SET: null,
};
export const POPUP_TYPE = {
  DELETE: 'delete',
  CREATE: 'create',
  CREATED: 'created',
  ERROR: 'error',
};
export const EIV_STATUS_NOT_RELEVANT = [EIV_STATUS.NOT_SET, EIV_STATUS.ARCHIVED];
export const EIV_STATUS_ALLOWED_TO_REGISTER_EXISTING_EMAIL = [null, 1];
export const EIV_STATUS_TO_SHOW = [2, 3, 4, 5, 6];

export const MTN_OTHER_DOCUMENT_ID = 0;

export const EIV_STATUS_TO_STRING = {
  null: 'Nicht vorhanden',
  1: 'Nicht vorhanden',
  2: 'Inaktiv',
  3: 'In Bearbeitung',
  4: 'Aktiv',
  5: 'Neu hinzugefügt',
  6: 'Zur Löschung vorgemerkt',
};
export const EIV_STATUS_TO_STRING_SALES_FORCE = {
  null: 'Nicht vorhanden',
  Active: 'Aktiv',
  pending: 'In Bearbeitung',
};
export const PFLEGENDE_BU = {
  [TENANT_ID.EDI]: {
    EDI: '2236',
  },
  [TENANT_ID.SHNG]: {
    SHNG: '20952',
    EENG: '70072',
    NNNG: '1577',
    HANSG: '402',
  },
  [TENANT_ID.AVA]: {
    AVA: '2235',
    WEVG: '20008',
  },
  [TENANT_ID.BAG]: {
    BAG: '20288',
  },
  [TENANT_ID.LVN]: {
    LVN: '803143',
  },
  [TENANT_ID.MTN]: {
    MTNSTROM: '803140',
    MTNGAS: '804360',
  },
};

export const PFLEGENDE_BU_ID_TO_NAME = {
  2236: 'E.DIS Netz GmbH',
  20952: 'Schleswig-Holstein Netz GmbH',
  70072: 'Schleswig-Holstein Netz GmbH',
  1577: 'Schleswig-Holstein Netz GmbH',
  402: 'Schleswig-Holstein Netz GmbH',
  2235: 'Avacon Netz GmbH',
  20008: 'Avacon Netz GmbH',
  20288: 'Bayernwerk Netz GmbH',
  803143: 'LEW Verteilnetz GmbH ',
  803140: 'Mitteldeutsche Netzgesellschaft Strom mbH',
  804360: 'Mitteldeutsche Netzgesellschaft Gas mbH',
};
export const NETWORK_OPERATOR_TO_PFLEGENDE_BU = {
  'Avacon Netz GmbH': '2235',
  'Bayernwerk Netz GmbH': '20288',
  'E.DIS Netz GmbH': '2236',
  'Schleswig-Holstein Netz GmbH': '20952',
  'LEW Verteilnetz GmbH': '803143',
  'Mitteldeutsche Netzgesellschaft Strom mbH': '803140',
  'Mitteldeutsche Netzgesellschaft Gas mbH': '804360',
};
export const PFLEGENDE_BU_TO_NETWORK_OPERATOR = Object.entries(
  NETWORK_OPERATOR_TO_PFLEGENDE_BU
).reduce((result, [operator, businessUnit]) => {
  result[businessUnit] = operator;
  return result;
}, {});
export const TENANT_TO_NAME = {
  [TENANT_ID.EDI]: 'E.DIS Netz GmbH',
  [TENANT_ID.SHNG]: 'Schleswig-Holstein Netz GmbH',
  [TENANT_ID.AVA]: 'Avacon Netz GmbH',
  [TENANT_ID.BAG]: 'Bayernwerk Netz GmbH',
  [TENANT_ID.LVN]: 'LEW Verteilnetz GmbH ',
  [TENANT_ID.MTN]: 'Mitteldeutsche Netzgesellschaft Strom mbH',
};
export const MY_TASK_STATUS = {
  1: 'Eingereicht',
  2: 'In Bearbeitung',
  3: 'Abgeschlossen',
};
export const EIV_OPERATING_MODE = {
  MAIN: 1,
  MAIN_AS_SIDE: 2,
  SIDE: 3,
  SIDE_AS_SIDE: 4,
  AUXILIARY: 5,
};

export const RESEAL_ALLOWED_CONTRACTS_IDS = {
  DEVELOPMENT: [1, 54],
  STAGING: [1, 54],
  UAT: [1, 54],
  PRODUCTION: [1, 52],
};
export const MISSING_PROVIDER_OBJECT = {
  title: 'Netzbetreiber nicht in Liste enthalten',
  value: -8888,
};
/** EIV master data id for unknown grid operator */
export const UNKNOWN_GRIDNET_PROVIDER_ID = 1;
export const UNKNOWN_GRIDNET_PROVIDER_TITLE = 'Netzbetreiber ist unbekannt';
export const NO_RESULTS_SENTINEL = { title: 'Keine Ergebnisse gefunden', value: -9999 };

/** EIV-approved Betriebsart IDs for Fachinteressent Tätigkeitsschwerpunkt */
export const FACHINTERESSENT_TAETIGKEITSSCHWERPUNKT_IDS = [
  36, // Anlagenhersteller
  95, // Netzbetreiber
  88, // Schule
  80, // Baufirma
  97, // Solarteure
  86, // Planer / Architekt
  98, // Fachverbände
  76, // Sonstige
];

export const KEYS_TO_GERMAN = {
  companyName1: 'Firmenname1',
  companyName2: 'Firmenname2',
  companyName3: 'Firmenname3',
  companyOwner: 'Firmeninhaber',
  b_anrede_id: 'b_anrede_id',
  taetigkeitsschwerpunkt: 'Tätigkeitsschwerpunkt',
  companyCountry: 'Land',
  companyStreet: 'Straße',
  companyStreetId: 'Straße_LokarefID',
  companyHouseNumber: 'Hausnummer',
  companyHouseNumberAddition: 'Hausnummerzusatz',
  companyPostal: 'PLZ',
  companyPostalCity: 'PLZ_Ort_LokarefID',
  companyCity: 'Ort',
  companyRegion: 'Ortsteil',
  companyRegionId: 'Ortsteil_LokarefID',
  mobile: 'Mobil',
  phone: 'Telefon',
  craftsChamberArea: 'Hwk-Bereich',
  craftsChamberNumber: 'Hwk-Nummer',
  craftsChamberDate: 'Hwk-Datum',
  businessRegistrationLocation: 'Gewerbeanmeldung Ort',
  businessRegistrationDate: 'Gewerbeanmeldung Datum',
  commercialRegisterNumber: 'HRA/B Nummer',
  commercialRegisterLocation: 'Amtsgericht',
  commercialRegisterDate: 'Letzte Änderung (Register)',
  gridProviderEnergy: 'Netzbetreiber Strom',
  foreignCompanyIdEnergy: 'Ausweisnummer Fremd Strom',
  gridProviderGas: 'Netzbetreiber Gas',
  foreignCompanyIdGas: 'Ausweisnummer Fremd Gas',
  eintragungsartStrom: 'Eintragungsart Strom',
  eintragungsartGas: 'Eintragungsart Gas',
};

export const BAG_KEYS = [
  'craftsChamberArea',
  'craftsChamberNumber',
  'craftsChamberDate',
  'businessRegistrationLocation',
  'businessRegistrationDate',
  'commercialRegisterNumber',
  'commercialRegisterLocation',
  'commercialRegisterDate',
];
export const BAG_LVN_KEYS = ['companyOwner'];
export const BRANCH_TYPE = {
  GAS: 'GAS',
  ENERGY: 'ENERGY',
};
export const BRANCH_TYPE_TO_VARIABLE_NAME = {
  [BRANCH_TYPE.GAS]: 'Gas',
  [BRANCH_TYPE.ENERGY]: 'Energy',
};
export const INSTALLER_ENTRIES = {
  NONE: 'none',
  MAIN_ENERGY_ONLY: 'mainEnergyOnly',
  MAIN_GAS_ONLY: 'mainGasOnly',
  GUEST_ONLY: 'guestOnly',
  MAIN_BOTH: 'mainBoth',
  MAIN_ENERGY_GUEST_GAS: 'mainEnergyGuestGas',
  GUEST_ENERGY_MAIN_GAS: 'guestEnergyMainGas',
};
export const INSTALLER_ENTRIES_ALLOW_EXPERT_EDITING = [
  INSTALLER_ENTRIES.GUEST_ONLY,
  INSTALLER_ENTRIES.MAIN_ENERGY_GUEST_GAS,
  INSTALLER_ENTRIES.GUEST_ENERGY_MAIN_GAS,
];
export const BRANCH_TYPE_TO_GERMAN_NAME = {
  [BRANCH_TYPE.GAS]: 'Gas',
  [BRANCH_TYPE.ENERGY]: 'Strom',
};

export const EIV_STATUS_TO_GERMAN_NAME = {
  [EIV_STATUS.ACTIVE]: 'Aktiv',
  [EIV_STATUS.INACTIVE]: 'Inaktiv',
  [EIV_STATUS.IN_PROGRESS]: 'In Bearbeitung',
};
export const EIV_STATUS_ALLOW_RENDER = [
  EIV_STATUS.ACTIVE,
  EIV_STATUS.INACTIVE,
  EIV_STATUS.IN_PROGRESS,
];
export const EIV_STATUS_ALLOW_EXPERT_EDITING = [EIV_STATUS.ACTIVE, EIV_STATUS.INACTIVE];
export const VALID_STATUSES_FOR_NEW_EXPERTS = [EIV_STATUS.ACTIVE, EIV_STATUS.NEW];
export const EIV_STATUS_ALLOW_EXPERT_RENDERING = [
  EIV_STATUS.ACTIVE,
  EIV_STATUS.INACTIVE,
  EIV_STATUS.IN_PROGRESS,
  EIV_STATUS.NEW,
  EIV_STATUS.DELETED,
];
export const EIV_STATUS_ALLOW_EXPERT_DELETION = [EIV_STATUS.ACTIVE, EIV_STATUS.NEW];
export const EIV_ENTRY_TYPE_TO_GERMAN_NAME = {
  main: 'Stamm',
  guest: 'Gast',
};
export const EIV_STATUS_NON_NULL_TYPES = ['main', 'guest'];
export const NE_ACTIVE_STEP = {
  EMAIL_INPUT: 0,
  BRANCH_SELECTION: 1,
  FORM: 2,
  FORM_UPLOAD: 3,
  RESULT: 4,
};
export const DEB_ACTIVE_PAGE = {
  FORM_PAGE: 0,
  FORM_UPLOAD: 1,
};
// Has to be in sync with env variables
export const STAGE = {
  LOCAL: 'local',
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  UAT: 'uat',
  PRODUCTION: 'production',
};

export const DOMAIN_PREFIX = {
  LOCAL: 'dev.',
  DEVELOPMENT: 'dev.',
  STAGING: 'qa.',
  UAT: 'uat.',
  PRODUCTION: '',
};

export const DOMAIN_CIAM_LOGIN_PREFIX = {
  LOCAL: 'login-dev.',
  DEVELOPMENT: 'login-dev.',
  STAGING: 'login-dev.',
  UAT: 'login-qa.',
  PRODUCTION: 'login.',
};

export const IAM_PROVIDER = {
  SALESFORCE: 'salesforce',
  OKTA: 'okta',
};

export const OKTA_DEFAULT_SCOPE = 'openid profile email';

export const UPLOAD_RESTRICTION_ERROR_MESSAGE = {
  TOTAL_FILE_SIZE: 'Die Gesamtgröße der Dateien darf 7 MB nicht überschreiten.',
  TOTAL_COUNT: 'Es dürfen maximal 10 Dateien hochgeladen werden.',
};

export const VALIDATION_CONSTANTS = {
  TOO_LONG: 'Zu lang',
  MANDATORY: 'Pflichtfeld',
  TOO_SHORT: 'Zu kurz',
  INVALID_EMAIL: 'Keine gültige E-Mail',
  INVALID_POSTAL: 'Keine gültige PLZ',
  INVALID_PHONE:
    'Keine gültige Telefonnummer. Erlaubte Vorwahlen: +49, +43, +41, +352, +32, +39, +386, +48, +45. Bitte nur Ziffern und führendes + verwenden; Zeichen wie / oder () sind nicht erlaubt.',
};
export const COUNTRY_OPTIONS = [
  { title: 'Deutschland', value: 'DE' },
  { title: 'Österreich', value: 'AT' },
  { title: 'Schweiz', value: 'CH' },
  { title: 'Luxemburg', value: 'LU' },
  { title: 'Belgien', value: 'BE' },
  { title: 'Italien', value: 'IT' },
  { title: 'Slowenien', value: 'SI' },
  { title: 'Polen', value: 'PL' },
  { title: 'Dänemark', value: 'DK' },
];
export const EIV_CHAR_LENGTH = {
  STANDARD_TEXT: 100,
  EMAIL: 64,
  FIRMENNAME1: 60,
  FIRMENNAME2: 60,
  FIRMENNAME3: 200,
  INHABER: 60,
  BUERO_ORTSTEIL: 32,
  BUERO_BUNDESLAND: 32,
  BUERO_LAND: 32,
  COMMUNICATION_EMAIL: 256,
  BUERO_STRASSE: 100,
  BUERO_HAUSNUMMER: 100,
  BUERO_PLZ: 100,
  BUERO_ORT: 40,
  TELEFON_GESCHAEFT: 100,
  TELEFON_WERKSTATT: 100,
  TELEFON_MOBIL: 100,
  B_NETZBETREIBER_NAME: 400,
  AUSWEISNR_FREMD: 160,
  EXPERT_NAME: 32,
};

export const STATIC_FIELDS = [
  'experts',
  'documentsTrigger',
  'expertTrigger',
  'changes',
  'isAddressPublic',
  'canSendMail',
  'informationOperators',
  'addressOperators',
  'pflegendeBU',
];
export const TASK_STATUS = {
  UNDEFINED: 'Undefiniert',
  NEW: 'Eingereicht',
  IN_PROGRESS: 'In Bearbeitung',
  FEEDBACK_PENDING: 'Rückmeldung ausstehend',
  FEEDBACK_GIVEN: 'Rückmeldung erfolgt',
  FINISHED: 'Abgeschlossen',
  CANCELLED: 'Abgebrochen',
};

export const OPEN_TASK_STATUSES = [
  TASK_STATUS.NEW,
  TASK_STATUS.IN_PROGRESS,
  TASK_STATUS.FEEDBACK_PENDING,
  TASK_STATUS.FEEDBACK_GIVEN,
];
// Only these statuses require an action from the installer and show the "!" in Meine Daten.
export const INSTALLER_ACTION_TASK_STATUSES = [TASK_STATUS.FEEDBACK_PENDING];
export const MEINE_AUFGABEN_CARD_ID = 'my-tasks';

export const MY_DATA_CARD_ID = {
  DOCUMENT_DOWNLOAD: 'document-download',
  DELETE_COMPANY: 'delete-company',
  DATA_PRIVACY: 'data-policy',
  DATA_MANAGEMENT: 'deb',
  SUB_ACCOUNTS: 'zusatzkonten',
};

export const FACHINTERESSENT_MY_DATA_CARD_DESCRIPTIONS = {
  DATENSCHUTZ: 'Informationen zum DSGVO - Zustimmung/Ablehnung zum Informationsversand',
  DATA_MANAGEMENT: 'Hier können Sie Ihre Daten verwalten.',
  DELETE_PORTAL_ACCESS: 'Hier können Sie die Löschung Ihres Portalzugangs beantragen.',
};

export const ONEEIGHTY_DAYS_IN_MINUTES = 259200;
export const BIRTHDATE = '23.02.2000';
export const BIRTHDATE_BASE_FORMAT = '2000-02-23';

export const TEST_VALIDITY_DATE_GERMAN_CAN_EXTEND = format(addDays(new Date(), -90), 'dd.MM.yyyy');
export const TEST_VALIDITY_DATE_GERMAN_CANNOT_EXTEND = format(
  addDays(new Date(), 181),
  'dd.MM.yyyy'
);
export const TEST_VALIDITY_DATE_BASE_FORMAT_CAN_EXTEND = format(
  addDays(new Date(), -90),
  'yyyy-MM-dd'
);

export const TEST_VALIDITY_DATE_BASE_FORMAT_CANNOT_EXTEND = format(
  addDays(new Date(), 181),
  'yyyy-MM-dd'
);
